//@ts-check

import React, { useState } from "react";
import "../styles/WebLandingPage.css";

import CampaignList, { getQueryName } from './CampaignList';


import WebResultsPage from './WebResultsPage';


// @ts-ignore
import luLogo from "../images/LU.svg";
// @ts-ignore
import drwText from "../images/donor_recognition_wall.svg";
// @ts-ignore
import luSeal from "../images/Seal.svg";


const rcs_NONE = 'rcs_NONE';
const rcs_DONORS = 'rcs_DONORS';
const rcs_CAMPAIGN = 'rcs_CAMPAIGN';

/**
 * @typedef {
        [rcs_NONE, null] |
        [rcs_DONORS, string] |
        [rcs_CAMPAIGN, string]
    } ResultsContentState 
 */


/**
 * @param {{
 *    searchString: string,
 *    onSearchStringChanged: (a: string) => void, 
 *    resultsContentState: ResultsContentState,
 *    onResultsContentStateChanged: (a: ResultsContentState) => void,
 *    goToResults: () => void }} props 
 * @returns {JSX.Element}
 */
function LandingPage(props) {

    const campaignCards = 
        CampaignList.map(c => (
                <div className="campaign-card__container" tabIndex={ 0 } role={ "link" }
                    onKeyDown={ (event) => {
                        // keyboard support for campaign items
                        if (event.key === "Enter") {
                            props.onSearchStringChanged("");
                            props.onResultsContentStateChanged([rcs_CAMPAIGN, getQueryName(c)]);
                            props.goToResults();
                        }
                } } 
                    onClick={() => { 
                        props.onSearchStringChanged("");
                        props.onResultsContentStateChanged([rcs_CAMPAIGN, getQueryName(c)]);
                        props.goToResults(); }}>
                    <label className="campaign-card__label">{c.title}</label>
                    <img className="campaign-card__image" src={c.image.browse.url} alt={c.title} />
                </div>
            ));

    const campaignCardsTable = [];

    let lastIndex = 0;
    for (let i = 0; i < campaignCards.length+3; i += 3)
    {
        campaignCardsTable.push(
            (<tr>
                <td>
                    {campaignCards[i]}
                </td>
                <td>
                    {campaignCards[i+1]}
                </td>
                <td>
                    {campaignCards[i+2]}
                </td>                
            </tr>)
        );
        lastIndex = i+2;
    }

    const remaining = campaignCards.length - lastIndex;

    switch (remaining) {
        case 2:
            campaignCardsTable.push(
                (<tr>
                    <td>
                        {campaignCards[lastIndex]}
                    </td>
                    <td>
                        {campaignCards[lastIndex+1]}
                    </td>      
                </tr>)
            );
            break;
        case 1:
            campaignCardsTable.push(
                (<tr>
                    <td>
                        {campaignCards[lastIndex]}
                    </td>             
                </tr>)
            );
            break;
        default:
            break;
    }

    function rtrim(str, chr) {
        if (str.indexOf(',') > -1) {
            str = str.split(',').reverse().join(' ');
        }
        var rgxtrim = (!chr) ? new RegExp('\\s+$') : new RegExp(chr+'+$');
        return str.replace(rgxtrim, '');
      }

    const performSearch = () => {
        props.onResultsContentStateChanged([rcs_DONORS, rtrim(props.searchString)]);
        props.goToResults();
    };

    return (
        <div className="web-app">
            <header className="App-header">
                <img src={luSeal} className="web-app-logo" alt="logo"/>
                <img src={luLogo} className="web-app-logo-name" alt="Liberty University"/>
                <img src={drwText} className="web-drw-text-name" alt="Donor Recognition Wall"/>

                <div className="donor-search__container">
                    <input className="donor-search__field" type="text" aria-label="Search for a donor by name" placeholder="Search for a donor by name" 
                        value={props.searchString}
                        onChange={e => props.onSearchStringChanged(e.target.value)} 
                        onKeyUp={e => {
                            if (e.key === "Enter") { performSearch(); }
                        }} />
                    <div 
                        className="donor-search__button__container" 
                        onClick={performSearch}>
                        <input className="donor-search__button" type="button" value="Search" aria-label="Submit search" />
                    </div>
                </div>

                <div className="or-divider__container" >
                    <div className="or-divider__line" />
                    <p className="or-divider__or">or</p>
                    <div className="or-divider__line" />
                </div>

                <div className="campaign-card-list__section">
                    <h2 className="campaign-card-list__title">Browse By Campaign</h2>
                    <div className="campaign-card-list__container">
                        <table className="campaign-card-list__container__table">
                            <tbody>
                                {campaignCardsTable}
                            </tbody>
                        </table>
                    </div>
                </div>
            </header>
        </div>
        );
}

/**
 * @param {{}} props 
 * @returns {JSX.Element|null}
 */
function WebLandingPage(props) {

    const [page, setPage] = useState("landing");
    const [searchString, setSearchString] = useState("");
    const handleSearchStringChanged = ss => setSearchString(ss);
    /**
     * @type {[ResultsContentState, React.Dispatch<React.SetStateAction<ResultsContentState>>]}
     */
    // @ts-ignore
    const [resultsContentState, setResultsContentState] = useState([rcs_NONE, null]);

    /**
     * @param {ResultsContentState} rcs 
     * @returns {void}
     */
    const handleResultsContentStateChanged = rcs => setResultsContentState(rcs);


    const goToResults = () => setPage("results");
    const goToLanding = () => setPage("landing");

    
    switch (page) {

        case "landing": return (
            <LandingPage 
                resultsContentState={resultsContentState} 
                onResultsContentStateChanged={handleResultsContentStateChanged} 
                searchString={searchString} 
                onSearchStringChanged={handleSearchStringChanged} 
                goToResults={goToResults} />);

        case "results": return (
            <WebResultsPage 
                resultsContentState={resultsContentState} 
                onResultsContentStateChanged={handleResultsContentStateChanged} 
                searchString={searchString} 
                onSearchStringChanged={handleSearchStringChanged}
                goToLanding={goToLanding} />);

        default: return null;
    }
};

// intercept browser back button and redirect to landing page // 
window.history.pushState(null, null, document.URL);
window.addEventListener('popstate', function(event) {
   window.location.reload();
});


export default WebLandingPage;
export { rcs_NONE, rcs_CAMPAIGN, rcs_DONORS };
